import { defineFormSchema } from '../../../shared/data/formSchema';
import { DEAL_KIND_META, DEAL_TYPE_OPTIONS, DEAL_PRIORITY_OPTIONS } from '../shared/utils/dealAdapters';
export function dealFormSchema(kind = 'proposta') {
  const meta = DEAL_KIND_META[kind];
  return defineFormSchema({
    id: kind === 'proposta' ? 'deals.proposal.create' : 'deals.in-progress.create',
    fields: [
      { name: 'name', label: 'Nome affare', required: true, primary: true },
      { name: 'description', label: 'Descrizione', type: 'textarea' },
      { name: 'tipoAffare', label: 'Tipo di affare', type: 'select', options: DEAL_TYPE_OPTIONS },
      { name: meta.priorityField, label: 'Priorità', type: 'select', options: DEAL_PRIORITY_OPTIONS },
      { name: 'clientId', label: 'Cliente', filter: { accessor: (row) => row.client || row.clientId } },
      { name: 'origineAffare', label: 'Origine (segnalato da)' },
      { name: 'staffId', label: 'Personale che gestisce', filter: { accessor: (row) => row.assignee || row.staffId } },
      { name: kind === 'proposta' ? 'dataPagamentoPrevista' : 'dataPagamento', label: 'Data scadenza', type: 'date' },
      { name: meta.amountField, label: 'Valore stimato', type: 'currency' },
      { name: 'probability', label: 'Percentuale (%)', type: 'number' },
      { name: 'dilazionamento.rate', label: 'Numero rate', type: 'number' },
      { name: 'dilazionamento.importiRate', label: 'Importi rate', type: 'currency', filter: { accessor: (row) => row.dilazionamento?.importiRate?.map((amount) => amount / 100) } },
      { name: 'dilazionamento.scadenze', label: 'Scadenze rate', type: 'date' },
      { name: 'stage', label: 'Fase' },
      { name: 'teamCoinvolto', label: 'Team coinvolto' },
      { name: meta.startDateField, label: meta.startDateLabel, type: 'date' },
      ...(kind === 'completato' ? [{ name: 'completedDate', label: 'Data completamento', type: 'date' }, { name: 'paymentStatus', label: 'Stato pagamento' }] : []),
    ],
  });
}
export const proposalFormSchema = dealFormSchema('proposta');
export const activeDealFormSchema = dealFormSchema('inCorso');
export const completedDealFormSchema = dealFormSchema('completato');
